<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OrganizationForm" });
import { Form } from "../../../../components/index.js";
import { createEventDispatcher } from "svelte";
import * as API from "../../services/api.js";
export let organization = {};
export let action = "create";
export let beforeSave = () => {
};
const dispatch = createEventDispatcher();
let formElement = null;
const onSave = (response) => {
    if ("code" in response) {
        return;
    }
    dispatch("save", response);
};
const onSubmit = async () => {
    await beforeSave();
    if (action === "update") {
        onSave(await API.updateOrganization({ organizationKey: organization._.key }, organization));
        return;
    }
    onSave(await API.createOrganization(organization));
};
export const submit = async () => {
    if (formElement === null) {
        return;
    }
    await formElement.submit();
};
export const isValid = () => {
    if (formElement === null) {
        return false;
    }
    return formElement.isValid();
};
</script>

<Form { onSubmit } id = { `${ action }-organization` } bind:this = { formElement }>

    <slot>
        <h3>{ action } Organization</h3>
        <pre>{ JSON.stringify(organization, null, 2) }</pre>
    </slot>

</Form>